import { useEffect, useState } from "react"

import LayoutPresetBuilds from "../../containers/PresetBuilds/LayoutPresetBuilds"
import { getApiHelper } from "../../util/apiHelpers"

function UserBuilds() {
  const [data, setData] = useState([])
  const user = JSON.parse(localStorage.getItem("permissionsDealerOMG"))
  const getPresets = () => {
    getApiHelper(`api/Presets?presetTypeId=1&dealerId=${user.userID}`)
      .then((res) => {
        setData(res.data)
      })
      .catch((e) => console.log(e))
  }

  useEffect(() => {
    getPresets()
  }, [])

  return (
    <div>
      <LayoutPresetBuilds nameBuilds="User" data={data} />
    </div>
  )
}

export default UserBuilds
